module.exports = __webpack_public_path__ + "img/image_1-a8ab462e.png";